(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-blog-page"]) return;
  try {
    
$(document).ready(function(){
  var num = 1;
  $(document.body).on('click', '.blog_showmore a', function(e){
    num++; e.preventDefault(); var t = $(this);
    var p = t.data('totalpages'); 
    t.after('<div id="loader" class="spinner-grow text-dark"></div>');
   if( num <= p ){
     $.ajax({
       type:"get",
       url:"https://veganessentials.com/blogs/news/?page="+num,
       success: function(resp){
         var data = $(resp).find('.ve_news_list').html();
         $('#ve_news_list').append(data);
       },
       complete: function(){
         $('#loader').remove();
       }
     });  
   } 
    if( num == p ){ t.hide(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yos-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yos-video-hero')) {
    customElements.define('yos-video-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('button');
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.updateButton = () => {
          const playing = !this.video.paused;
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pause : this.toggle.dataset.play);
          this.toggle.firstElementChild.textContent = playing ? 'Ⅱ' : '▶';
        };
        this.loadVideo = () => {
          this.video.pause();
          this.classList.remove('is-playing', 'has-frame');
          const source = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
          this.video.poster = this.mobile.matches ? this.dataset.mobilePoster : this.dataset.desktopPoster;
          this.video.autoplay = !this.reduced.matches && !this.userPaused;
          this.video.removeAttribute('src');
          this.source = source;
          if (!this.reduced.matches && source) this.video.src = source;
          this.video.load();
          this.toggle.hidden = !source;
          if (!this.reduced.matches && !this.userPaused && source) this.startVideo();
          this.updateButton();
        };
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) { this.userPaused = false; this.startVideo(); }
          else { this.userPaused = true; this.video.autoplay = false; this.video.pause(); }
        }, options);
        this.video.addEventListener('playing', () => { this.classList.add('is-playing', 'has-frame'); this.updateButton(); }, options);
        this.video.addEventListener('pause', () => { this.classList.remove('is-playing'); this.updateButton(); }, options);
        this.video.addEventListener('error', () => { this.classList.remove('is-playing', 'has-frame'); this.updateButton(); }, options);
        this.resumeAutomatically = () => {
          if (!this.userPaused && !this.reduced.matches && !document.hidden && this.video.paused) this.startVideo();
        };
        this.video.addEventListener('canplay', this.resumeAutomatically, options);
        window.addEventListener('pageshow', this.resumeAutomatically, options);
        this.visibilityObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.resumeAutomatically();
        }, { threshold: 0.1 });
        this.visibilityObserver.observe(this.video);
        this.mobile.addEventListener('change', this.loadVideo, options);
        this.reduced.addEventListener('change', this.loadVideo, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (!this.userPaused && !this.reduced.matches) this.startVideo();
        }, options);
        this.loadVideo();
      }
      async startVideo() {
        if (!this.source) return;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.autoplay = !this.reduced.matches && !this.userPaused;
        if (!this.video.getAttribute('src')) { this.video.src = this.source; this.video.load(); }
        try { await this.video.play(); } catch (_) { this.updateButton(); }
      }
      disconnectedCallback() { this.visibilityObserver?.disconnect(); this.events?.abort(); this.video?.pause(); this.initialized = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
